WiseMetering.Collection.Opportunities = WiseMetering.Collection.extend({
    hasOrganization: true,
    model: WiseMetering.Model.Opportunity,
    url: '/opportunities',

    findBySiteId: function(siteId) {
        return new WiseMetering.Collection.Opportunities(
            this.filter(opportunity => opportunity.get('site_id') === siteId)
        );
    }
});
